
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","data-name":"vuesax/linear/profile-2user"}},[_c('path',{attrs:{"d":"M19.141 22.977a3.842 3.842 0 00-.7 0 9.4 9.4 0 11.7 0z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M34.103 8.283a7.393 7.393 0 017.4 7.4 7.408 7.408 0 01-7.125 7.4 2.387 2.387 0 00-.55 0M8.793 30.045c-5.115 3.424-5.115 9 0 12.408 5.813 3.892 15.346 3.892 21.164.001 5.115-3.424 5.115-9 0-12.408-5.8-3.868-15.33-3.868-21.164-.001zM38.036 41.708a10.225 10.225 0 004.143-1.839c3.3-2.473 3.3-6.553 0-9.026a10.513 10.513 0 00-4.08-1.818"}})])])
          )
        }
      }
    